<template>
  <div class="fullHeight">
    <Card
        iconclass="icon-icon-info mypage-title-icon"
        :page_title="page_title"
        >
        <div class="col m-2">
            <div v-if="golfCourseCode.length >= 2" class="row mb-3">
                <div class="col-sm-2 align-self-center">ゴルフ場</div>
                <select
                    class="form-control col-sm-4"
                    v-model="golfCode"
                    @change="getContactMessgaeList"
                    :disabled="this.$store.state.mypage.reserveNo !== 0"
                    >
                    <option v-for="data in golfCourseCode"
                            :key="data.golf_name"
                            :value="data.golf_code">
                            {{ data.golf_name }}
                    </option>
                </select>
            </div>
            <div class="contact-message-body scrollY scrollXhidden row">
                <ul class="p-2 w-100">
                    <span v-for="d in desserts"
                        :key="d.id"
                        class="d-flex flex-column">
                        <small v-if="d.day.dispFlag" class="mx-auto my-2">{{ d.day.day }}</small>
                        <li
                            
                            style="max-width: 70%;"
                            class="card my-1"
                            :class="{
                                'says': d.send_id,
                                'mycomment': !d.send_id,
                                'align-self-end': !d.send_id,
                                'align-self-start': d.send_id,
                            }"
                        >
                            <div>
                                <div class="content text-justify">{{ d.message }}</div>
                                <!-- <small>
                                    <p
                                        class="py-1"
                                        :class="{ 'text-right': !d.send_id }"
                                    >{{ d.created_at }}
                                    </p>
                                </small> -->
                            </div>
                            <small>
                                    <p
                                        :class="{ 
                                            'small-mycomment-times': !d.send_id,
                                            'small-says-times': d.send_id
                                        }"
                                    >{{ d.day.time }}
                                    </p>
                            </small>
                        </li>
                    </span>
                </ul>
            </div>
            <div class="row mb-2">
                <textarea
                    class="form-control"
                    placeholder="メッセージを入力してください"
                    v-model="message"
                    cols="30"
                    rows="4"></textarea>
            </div>
            <div class="row justify-content-center">
                <button
                    class="btn btn-outline-info col-sm-4"
                    @click="postMessage"
                >登録</button>
            </div>
        </div>
    </Card>
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { GET_CODE_LIST } from '../../constants/codelist';
import { GET_GOLF_COURSE_NAME } from '../../constants/golf_course';
import {
    GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO,
    GET_CONTACT_MESSAGE_LIST,
    POST_MESSAGE,
    SEND_INQUIRY_NOTICE_EMAIL } from '../../constants/contact';
import { utilityMixin } from '../../mixins/utility';

export default {
    components: {
        MypageSideMenu,
        Card,
        ConfirmDialog
    },
    mixins: [utilityMixin],
    data () {
        return {
            // 現在ログインしているメンバーID
            memberNo: '',
            // 予約番号
            reserveNo: '',
            // ページタイトル
            page_title: 'Chatbox',
            // キャンセル時に使用するID
            cancelData: {
              id: ''
            },
            cancelDialog: '',
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            golfGroupCode: process.env.MIX_GROUP_CODE,
            golfCode: '',
            // ゴルフ場情報
            golfCourseCode: [],
            // メッセージ情報
            desserts: [],
            // メッセージ
            message: '',
            // プラン名
            planName: '',
            notReserve: '000000000000'
        };
    },
    watch: {
        desserts: function () {
            this.$nextTick(function() {
                var container = this.$el.querySelector('.contact-message-body');
                container.scrollTop = container.scrollHeight;
            });
        }
    },
    async created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        if (sessionStorage.getItem('storageReserveNo')) {
            if (this.$store.state.mypage.reserveNo === 0) {
                this.reserveNo = this.notReserve;
            } else {
                const strageData = JSON.parse(sessionStorage.getItem('storageReserveNo'));
                this.reserveNo = strageData.mypage.reserveNo;
            }
        }
        this.golfCode = await this.getGolfCourse();
        this.planName = this.$store.state.mypage.planName;
        await this.getContactMessgaeList();
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit("mypage/pushReserveNo", 0);
        this.$store.commit("mypage/pushPlanName", '');
        const strageData = sessionStorage.removeItem('storageReserveNo');
        next();
    },
    methods: {
        /** ----------------------------------------------
         * メッセージ一覧を取得
         * ---------------------------------------------- */
        async getContactMessgaeList () {
            // ゴルフ場への問い合わせの場合
            if (this.reserveNo == this.notReserve) {
                await this.getContactMessgaeListMemberNo();
            // 予約に対する問合せの場合
            } else {
                await this.getContactMessgaeListReserveNo();
            }
        },
        /** ----------------------------------------------
         * メッセージ一覧を取得（予約番号）
         * ---------------------------------------------- */
        getContactMessgaeListReserveNo () {
            this.$apollo.query({
                query: GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCode,
                    reserve_no: this.reserveNo
                }
            }).then(res => {
                this.MakeMessageList(res.data.getContactsMessageListByReserveNo.Message);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            })
        },
        /** ----------------------------------------------
         * メッセージ一覧を取得（会員番号）
         * ---------------------------------------------- */
        getContactMessgaeListMemberNo () {
            this.$apollo.query({
                query: GET_CONTACT_MESSAGE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCode,
                    member_no: this.memberNo,
                    reserve_no: this.reserveNo
                }
            }).then(res => {
                this.MakeMessageList(res.data.getContactsMessageList.Message);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            });
        },
        /** ----------------------------------------------
         * メッセージ一覧作成
         * ---------------------------------------------- */
        MakeMessageList: function (messageList) {
            this.desserts.splice(0, this.desserts.length);
            var monitorDateList = [];
            for (let message of messageList) {
                var substrDate = message.created_at.substr(0, 10);
                var substrTimr = message.created_at.substr(-8);
                var splitDate = substrDate.split('-');
                var splitTime = substrTimr.split(':');
                var year = splitDate[0];
                var month = splitDate[1];
                var day = splitDate[2];
                var dateObj = new Date(Number(year), Number(month) - 1, Number(day));
                var JpStrDate = this.getDateBindStrJapanese(dateObj);
                var judgeDay = this.getDayJapanese(dateObj);
                var day = {};
                if (monitorDateList.includes(JpStrDate)) {
                    day = {
                        day: JpStrDate + '(' + judgeDay + ')',
                        time: splitTime[0] + ':' + splitTime[1],
                        dispFlag: false
                    };
                } else {
                    day = {
                        day: JpStrDate + '(' + judgeDay + ')',
                        time: splitTime[0] + ':' + splitTime[1],
                        dispFlag: true
                    };
                }
                monitorDateList.push(JpStrDate);
                this.desserts.push({
                    completed: message.completed,
                    day: day,
                    id: message.id,
                    message: message.message,
                    send_id: message.send_id
                });
            }
        },
        // /** ----------------------------------------------
        //  * ゴルフ場を取得
        //  * ---------------------------------------------- */
        async getGolfCourse () {
            return this.$apollo.query({
                query: GET_GOLF_COURSE_NAME,
                variables: {
                    golf_group_code: this.golfGroupCode
                }
            }).then(res => {
                this.golfCourseCode.push(...res.data.getGolfCourse);
                if (this.$store.state.mypage.reserveNo === 0) {
                    return res.data.getGolfCourse[0].golf_code;
                } else {
                    return this.$store.state.mypage.useGolfCode;
                }
            })
        },
        /** ----------------------------------------------
         * 投稿完了通知メールを送信する
         * ---------------------------------------------- */
        SendNoticeEmail () {
            try {
                this.$apollo.mutate({
                    mutation: SEND_INQUIRY_NOTICE_EMAIL,
                    variables: {
                        reserve_no: this.reserveNo,
                        golf_group_code: this.golfGroupCode,
                        golf_code: this.golfCode,
                        member_no: null,
                        family_name: this.$store.state.auth.loginMember.family_name,
                        given_name: this.$store.state.auth.loginMember.given_name
                    }
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * メッセージを送信する
         * ---------------------------------------------- */
        postMessage () {
            // 空なら返却
            if (this.message === '') return;

            this.$apollo.mutate({
                mutation: POST_MESSAGE,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCode,
                    member_no: this.memberNo,
                    reserve_no: this.reserveNo,
                    send_id: null,
                    message: this.message,
                    completed: 0
                }
            }).then(res => {
                const result = res.data.postMessage.result;
                if(result === 1){
                //    this.$set(this.processing, 'result', 1);
                //    this.$set(this.processing, 'resultText', 'キャンセルが完了しました。');
                   this.message = '';
                    // 通知メールを送る
                    this.SendNoticeEmail();
                    // ゴルフ場への問い合わせの場合
                    if (this.reserveNo == this.notReserve) {
                        this.getContactMessgaeListMemberNo();
                    // 予約に対する問合せの場合
                    } else {
                        this.getContactMessgaeListReserveNo();
                    }
                }else if (result === 0) {
                    throw res.data.errorMessage;
                    throw new Error(res.errorMessage);
                }
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            });
        },
        /** ----------------------------------------------
         * キャンセル処理を表示
         * ---------------------------------------------- */
        cancelReserve () {
            this.$apollo.mutate({
                mutation: CANCEL_RESERVE_FROM_MYPAGE,
                variables: {
                    reserve_no: this.cancelData.id
                }
            }).then(res => {
                const result = res.data.cancelReserveFromWeb.result;
                if(result === 1){
                   this.$set(this.processing, 'result', 1);
                   this.$set(this.processing, 'resultText', 'キャンセルが完了しました。');
                   this.cancelOverlayHidden();
                   this.getReservesList();
                }else if (result === 0) {
                    throw res.data.errorMessage;
                    throw new Error(res.errorMessage);
                }
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            });
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        cancelOverlayDisplay (data) {
            this.$set(this.cancelData, 'id', data.reserve_no);
            this.cancelDialog = !this.cancelDialog;
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        cancelOverlayHidden (data) {
          this.cancelDialog = !this.cancelDialog;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * 予約状況オブジェクトを取得
         * ---------------------------------------------- */
        getCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: 'reserve_situation',
                    default_display: 0
                }
            }).then(res => {
                const data = res.data.GetCodeList.CodeList;
                data.forEach(el => {
                    this.reserve_situation_obj[String(el.code)] = el.code_name;
                });
            });
        }
    }
}

</script>

<style scoped>
ul{
    padding: 0;
    margin: 0;
}
li{
    list-style: none;
}
p{
    margin: 0;
}
textarea{
    width: 100%;
    resize: none;
    white-space: pre-wrap;
}
</style>
